import axios from "axios"

import { pingRedirectURL } from "./utils/utils"

export const AuthConfig = {
    clientSecret: process.env.REACT_APP_CLIENT_SECRET,
    clientId: "After sales 365",
    CALL_BACK_URL: "https://aftersales365-frontend/landing",
    AUTH_URL: "https://fedauth.pg.com",
    TOKEN_URL: "https://fedauth.pg.com/as/token.oauth2",
    maxAge: 86400,  //3600 old  value,
    API_URI: "https://api.pingone.com/v1",
    AUTH_URI: "https://auth.pingone.com",
    environmentId: "After Sales 365",
    responseType: "",
    grantType: "authorization_code",
    redirectUri: pingRedirectURL(),
    logoutRedirectUri: pingRedirectURL(),
    scope: "profile address email phone openid",
    prompt: "login",
    tokenEndpointAuthMethod: "client_secret_post"
}

export const generateRandomValue = () => {
    let crypto = window.crypto || window.msCrypto
    let D = new Uint32Array(2)
    crypto.getRandomValues(D)
    return D[0].toString(36)
}

export const authorize = (state, nonce) => {                 
    let authUrl = `${getBaseApiUrl(
        true)}/as/authorization.oauth2?` +
        `client_id=${AuthConfig.clientId}&` +
        `redirect_uri=${AuthConfig.redirectUri}&`+
        `response_type=${AuthConfig.responseType ? AuthConfig.responseType: "code"}` +
        (AuthConfig.scope ? `&scope=${AuthConfig.scope}` : "")+
        (AuthConfig.maxAge ? `&max_age=${AuthConfig.maxAge}` : "")+
        (state ? `&state=${state}` : "")+
        (nonce ? `&nonce=${nonce}` : "")
    window.location.href = authUrl
}

export const getToken = async (code) => {
    try {
        const response = await axios.post("https://fedauth.pg.com/as/token.oauth2", {
            grant_type: "authorization_code",
            code: code,
            redirect_uri: AuthConfig.redirectUri
        })
        sessionStorage.setItem("access_token", response.data.access_token)
        sessionStorage.setItem("id_token", response.data.id_token)
        sessionStorage.setItem("refreshToken", response.data.refresh_token)
        return response.data
    }
    catch (error){
        console.log(error)
    }
}

export const refreshToken = async () => {
    const refreshToken = sessionStorage.getItem("refreshToken")
    if(!refreshToken) return null
    try {
        const response = await axios.post("https://fedauth.pg.com/as/token.oauth2", {
            grant_type: "refresh_token",
            refresh_token: refreshToken
        })
        sessionStorage.setItem("access_token", response.data.access_token)
        sessionStorage.setItem("id_token", response.data.id_token)
        return response.data
    }
    catch (error){
        console.log(error)
    }
}


const getBaseApiUrl = (useAuthUrl) => {
    return useAuthUrl ?
        AuthConfig.AUTH_URL : // base API URL for auth things like the flow orchestration service
        AuthConfig.API_URI // base API URL for non-auth things
}
